import type { JSX } from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import type { NavItem } from './navigation';

interface NavItemLinkProps {
  item: NavItem;
  onClick?: () => void;
  isCollapsed: boolean;
}

export function NavItemLink({ item, onClick, isCollapsed }: NavItemLinkProps): JSX.Element {
  const link = (
    <NavLink
      to={item.path}
      onClick={onClick}
      data-testid={`nav-item-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
      className={({ isActive }) =>
        cn(
          'flex items-center rounded-lg text-sm font-medium transition-colors',
          isCollapsed ? 'w-10 h-10 justify-center' : 'gap-3 px-3 py-2',
          isActive
            ? 'bg-primary text-primary-foreground'
            : 'text-muted-foreground hover:bg-muted hover:text-foreground'
        )
      }
    >
      <item.icon className="h-4 w-4 shrink-0" />
      {!isCollapsed && <span data-testid="nav-item-label">{item.label}</span>}
    </NavLink>
  );
  return isCollapsed ? (
    <Tooltip>
      <TooltipTrigger asChild>{link}</TooltipTrigger>
      <TooltipContent side="right">{item.label}</TooltipContent>
    </Tooltip>
  ) : (
    link
  );
}
